import { getStandorte } from '../../../helpers/getStandorte';
import { i18n } from '../../../i18n/i18n';
import * as React from 'react';

interface StandortAuswahlProps extends React.ClassAttributes<any> {
    data: any;
    disabled?: boolean;
    fontSize?: number;
    label?: string;
    filter?: (standort: any, callback: (visible: boolean) => void) => void;
    onStandortChange: (standort: number) => void;
    padding?: number;
    standort: number;
    width?: number;
    renderClean?: boolean;
}

export class StandortAuswahl extends React.Component<StandortAuswahlProps, {}> {

    constructor(props: any) {
        super(props);
        const standorte: any[] = getStandorte(props.data) || [];
        this.standorte = [];

        if (typeof props.filter === 'function') {
            standorte.forEach((standort: any) => props.filter(standort, (visible: boolean) => {
                if (visible) {
                    this.standorte.push(standort);
                }
            }));
        } else {
            this.standorte = standorte;
        }
    }

    private standorte: any[] = [];

    renderCleanElements(): JSX.Element {
        const standorte: any[] = getStandorte(this.props.data) || [];

        return <>
            {this.props.label &&
                <label>
                    {this.props.label}
                </label>
            }
            <select
                id='standort-auswahl'
                value={this.props.standort}
                disabled={this.props.disabled || standorte.length < 2}
                onChange={(event: any) => this.props.onStandortChange(+event.target.value)}
            >
                {!standorte.length &&
                    <option>[{i18n('Nicht verfügbar', 'sys')}]</option>
                }
                {standorte.length > 1 &&
                    <option
                        key='standort-'
                        value={0}
                    >
                        [{i18n('Gesamtunternehmen', 'sys')}]
                    </option>
                }
                {this.standorte.map((standort: any, index: number) =>
                    <option
                        key={`standort-${index}`}
                        value={standort.tid}
                    >
                        {standort.name}
                    </option>
                )}
            </select>
        </>;
    }

    render(): JSX.Element {
        if (this.props.renderClean) {
            return this.renderCleanElements();
        }
        const standorte: any[] = getStandorte(this.props.data) || [];

        return (
            <div
                style={{
                    flex: 1, flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: typeof this.props.padding === 'number' ? this.props.padding : 3
                }}
            >
                {this.props.label &&
                    <div style={{ fontSize: this.props.fontSize && this.props.fontSize, marginRight: 10 }}>
                        {this.props.label}
                    </div>
                }
                <select
                    id='standort-auswahl'
                    style={{
                        fontSize: this.props.fontSize && this.props.fontSize, width: this.props.width ? this.props.width : 'auto',
                        maxWidth: this.props.width ? this.props.width : 190, minHeight: 18
                    }}
                    value={this.props.standort}
                    disabled={this.props.disabled || standorte.length < 2}
                    onChange={(event: any) => this.props.onStandortChange(+event.target.value)}
                >
                    {!standorte.length &&
                        <option>[{i18n('Nicht verfügbar', 'sys')}]</option>
                    }
                    {standorte.length > 1 &&
                        <option
                            key='standort-'
                            value={0}
                        >
                            [{i18n('Gesamtunternehmen', 'sys')}]
                        </option>
                    }
                    {this.standorte.map((standort: any, index: number) =>
                        <option
                            key={`standort-${index}`}
                            value={standort.tid}
                        >
                            {standort.name}
                        </option>
                    )}
                </select>
            </div>
        );
    }
}
